import http from "./http"; // axios instance

/* ================================
   GET WITHDRAWALS (ALL / FILTER)
   ================================ */

// status = pending | approved | rejected
export const getAdminWithdrawals = async (status = null) => {
  let url = "admin_get_withdrawals";

  if (status) {
    url += `?status=${status}`;
  }

  const res = await http.get(url);
  return res.data;
};

/* ================================
   GET WITHDRAWAL BY ID
   ================================ */
export const getAdminWithdrawalById = async (id) => {
  const res = await http.get(`admin_get_withdrawals?id=${id}`);
  return res.data;
};

/* ================================
   APPROVE WITHDRAWAL
   ================================ */
export const approveAdminWithdrawal = async (request_id) => {
  const res = await http.post("admin_approve_withdraw", {
    request_id,
  });
  return res.data;
};

/* ================================
   REJECT WITHDRAWAL
   ================================ */
export const rejectAdminWithdrawal = async (request_id, remark) => {
  const res = await http.post("admin_reject_withdraw", {
    request_id,
    remark,
  });
  return res.data;
};
